import { useEffect, useState } from 'react';
import { useLanguageService } from '../services/languageService';
import { useIntl } from 'react-intl';

export function useFormatLocale() {
  const [rawLocales, setRawLocales] = useState([]);
  const [formattedLocales, setFormattedLocales] = useState({});
  const { getLocales } = useLanguageService();
  const intl = useIntl();

  useEffect(() => {
    const fetchLocales = async () => {
      try {
        const response = await getLocales();
        if (response?.locales) setRawLocales(response.locales);
      } catch (err) {
        console.error(err);
      }
    };

    fetchLocales();
  }, []);

  useEffect(() => {
    if (!rawLocales.length) return;

    const formatted = rawLocales.reduce((acc, item) => {
      if (!item?.locale) return acc;

      acc[item.locale] = {
        locale: item.locale,
        country: item.country,
        language: item.language,
        countryText: intl.formatMessage({ id: `loginPage.country.${item.country}` }),
        languageText: intl.formatMessage({ id: `loginPage.${item.language}` }),
      };
      return acc;
    }, {});

    setFormattedLocales(formatted);
  }, [rawLocales, intl.locale]);

  return { locales: formattedLocales };
}
